import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MasterService } from 'src/app/services/master-mom.service';
import { ToastrUtilsService } from 'src/app/services/toastr-utils.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FilterPipe } from '../../services/filterpipe';
import { UserService } from '../../services/user.service';
import { ToasterService } from '../../toaster/toaster.service';
import { UserProfileInfo } from '../../Models/userprofileinfo';
import { environment } from 'src/environments/environment';
import { NgForm } from '@angular/forms';
import { applnInfo } from '../../Models/ApplnInfo';
import { Subscription } from 'rxjs';
import { UtilityService } from '../../services/utility.service';
import { RSAHelper } from '../../services/RSAHelper';
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    providers: [ToastrUtilsService]
})

export class SidebarComponent implements OnInit {
    @ViewChild('closeBtn') closeBtn: ElementRef;
    @ViewChild('closeBtnApps') closeBtnApps: ElementRef;
    imgdynamicurl = '';
    subscription: Subscription;
    constructor(private userService: UserService, public RSAHelper: RSAHelper, private utilservice: UtilityService, public router: Router, public masterservice: MasterService, private spinner: NgxSpinnerService, private toaster: ToastrUtilsService) {
        this.imgdynamicurl = environment.imgdynamicurl;
        this.subscription = this.utilservice.getData().subscribe(data => {
            if (this.useremail != null)
                this.RefreshSecurityToken(this.useremail);
        });
    }
    submitcnt: number = 0;

    public myApps = -1;

    objapplnInfo: applnInfo = new applnInfo();
    user: any = [];
    sectionname: string = ""; sectionid: string = "";
    animation = 'pulse'; savesection: boolean = false;
    contentLoaded = false;
    intervalId; limit = 10;
    page = 1;
    txtFilter = ''; p = 1; userSectionlist: any = []; applnList: any = []; userprofileInfo: any = [];
    sectionformvalue: string = "";
    useremail: string = "";
    ngOnInit() {
        try {

            this.user = this.userService.getUserInfo();
            if (!environment.production) {
                this.useremail = environment.testEmail;
            }
            else {
                if (this.user != null) //this.router.navigateByUrl("/login");
                    this.useremail = this.user.email;
            }

            setTimeout(() => {
                this.contentLoaded = true;
            }, 0);

            this.intervalId = setInterval(() => {
                this.animation = this.animation === 'pulse' ? 'progress-dark' : 'pulse';
            }, 0);

            this.RefreshSecurityToken(this.useremail);
        } catch (err) { console.log(err); }
    }

    RefreshSecurityToken(userEmail) {
        try {

            const objTxnData = {
                "email": userEmail,
                "isExternal": environment.isExternal
            };
            let encryptedioparam = this.RSAHelper.encryptWithPublicKey(JSON.stringify(objTxnData));
            this.masterservice.refreshToken(JSON.stringify(encryptedioparam)).subscribe((result: any) => {

                sessionStorage.removeItem('iammwtoken');
                sessionStorage.setItem('iammwtoken', result.token);
                this.LoadMenu(this.useremail);

            },
                (error) => {
                    sessionStorage.removeItem('iammwtoken');
                    this.spinner.hide();
                }
            ).add(() => {
                this.spinner.hide();
            });
        }
        catch (err) { console.log(err); }
    }

    LoadMenu(userEmail: string) {
        try {
            const objTxnData = {
                "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(userEmail))
            };
            console.log('From sidebar');
            const currentUrl = this.router.url;
            console.log('Current URL:', currentUrl);

            if(currentUrl=='/home/AppCatalog')
            {
                this.myApps=2;
            }
            else
            {
                this.myApps=1;
            }

            this.masterservice.allUserSections(JSON.stringify(objTxnData)).subscribe((result: any) => {
                this.userSectionlist = result.data;
                this.contentLoaded = true;
                console.log(this.userSectionlist);
                setTimeout(() => { this.spinner.hide(); }, 1000);
            },
                (error) => {
                    console.log(error);
                    this.contentLoaded = false;
                    // this.toaster.ErrorCustomMessage('Unable to load Menu.');
                    this.spinner.hide();
                }
            ).add(() => {
                // Called when operation is complete (both success and error)          
                this.spinner.hide();
            });
        } catch (err) { console.log(err); }
    }

    logout() {
        try {
            console.log('idle time out');

            this.userService.logout();
            sessionStorage.removeItem('iammwtoken');
            // window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';
            try {

                console.log('idle time out step 2');
                window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';

                setTimeout(function () {
                    console.log('idle time out step 3');
                    window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';
                }, 100);


            }
            catch (err) {
                console.log(err);
                console.log('idle time out step 2');
                window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';

                setTimeout(function () {
                    console.log('idle time out step 3');
                    window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';
                }, 100);

            }

        }
        catch (err) {
            console.log(err);
           // setTimeout(function () {
                console.log('idle time out step 4');
                window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';
           // }, 100);

            setTimeout(function () {
                console.log('idle time out step 4');
                window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';
            }, 600);
        }
    }

    LoadApplication() {
        try {
            debugger;
            var loginemail: string = "";
            loginemail = this.getuserdetails();
            if (loginemail == "") { this.toaster.ErrorCustomMessage('User Identification failed'); return; }
            const objTxnData = {
                "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(loginemail)),
                "isExternal": this.RSAHelper.encryptWithPublicKey(JSON.stringify(environment.isExternal))
            };

            this.masterservice.allApplns(JSON.stringify(objTxnData)).subscribe((result: any) => {
                this.applnList = [];
                //this.applnList = result.data;
                var resultdata = result.data;
                for (let i = 0; i < resultdata.length; i++) {
                    let appid = resultdata[i].appid;
                    //if (this.popupdata1.filter(item => item.appid === appid) == 0)
                    for (let j = 0; j < resultdata[i].applicationInfo.length; j++) {
                        this.applnList.push(resultdata[i].applicationInfo[j]);
                    }
                }
                setTimeout(() => { this.spinner.hide(); }, 1000);
            },
                (error) => {
                    //console.log(error);
                    // this.toaster.ErrorCustomMessage('There was an unexpected error.');
                    this.spinner.hide();
                }
            ).add(() => {
                // Called when operation is complete (both success and error)
                // this.spinner.hide();
                this.spinner.hide();
            });
        } catch (err) { console.log(err); }
    }

    clearapplndata() {
        this.myApps = 1;
        try {
            this.objapplnInfo.applnlogo = ""; this.objapplnInfo.applnname = "";
            this.objapplnInfo.applnurl = "";
        }
        catch (err) {
            console.log(err);
        }
    }

    openhome() {
        this.myApps = 0;
        this.router.navigateByUrl("/home").then(() => {
            //window.location.reload()
            //this.router.onSameUrlNavigation = 'reload';
            this.utilservice.updatesidebar("reload home");
        });
    }

    onSubmit(form: NgForm, formname: string) {
        debugger;
        try {
            if ((formname == "addapplicationform") && (form.valid)) {
                this.submitcnt = this.submitcnt + 1;
                //if(this.submitcnt==1){
                this.addApplication();
                //}
                console.log(this.submitcnt);
            }
            else if ((formname == "addsectionform")) {
                this.submitcnt = this.submitcnt + 1;
                this.sectionformvalue = form.value.sectionname;
                if (form.valid) this.AddNewSection();
            }
        }
        catch (err) { console.log(err); }
    }

    AddNewSection() {
        try {

            this.spinner.show();
            this.useremail = this.getuserdetails();
            /*if((this.userprofileInfo==null)||(this.userprofileInfo==""))
            {this.userprofileInfo=this.userService.getUserProfileInfo(this.useremail);}
            */
            /*if(this.userprofileInfo!="")
            {
                this.userprofileInfo=JSON.parse(this.userprofileInfo);
            }*/
            const selectedApps = this.applnList.filter(item => item.checked === true);
            if (selectedApps.length == 0) {
                this.toaster.showWarningToaster('Please select apps');
                return;
            }
            if (this.sectionname.trim() == "") {
                this.toaster.showWarningToaster("Please enter section name");
                return;
            }
            //console.log(selectedApps);
            var appID = '';
            for (var apps of selectedApps) {
                appID = appID + "," + apps.appid;
            }
            if (appID.substring(0, 1) == ",") appID = appID.slice(1);
            console.log(appID);

            this.userService.getUserProfileInfo(this.useremail).
                subscribe((result: any) => {
                    var response;
                    if (result.data == undefined) {
                        response = result;
                        this.userprofileInfo = response;
                    }
                    else { response = result.data; this.userprofileInfo = JSON.parse(this.userService.loadprofiledata(response)); }
                    //const response = result;
                    if (response != null) {
                        const objTxnData = {
                            "sectionname": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.sectionname)),
                            "employeeuno": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.userprofileInfo.employeeuno)),
                            "appid": this.RSAHelper.encryptWithPublicKey(JSON.stringify(appID)),
                            "PRNumber": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.userprofileInfo.userPRnumber)),
                            "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.useremail))
                        }

                        this.masterservice.AddNewSection(JSON.stringify(objTxnData))
                            .subscribe((result: any) => {
                                const response = result.data;
                                if (response.dictionary.IntResult > 0) {
                                    this.toaster.SuccessCustomMessage('Section added successfully.');
                                    this.closeBtn.nativeElement.click();
                                    //redirect to myApps page                        
                                    this.LoadApplication();
                                    this.LoadMenu(this.useremail);
                                    this.utilservice.updatesidebar("section added successfully");
                                    //this.router.navigate(['home']);
                                    //window.location.reload();
                                } else {
                                    if (response.dictionary.StringResult.includes('ORA-00001: unique constraint')) {
                                        this.toaster.ErrorCustomMessage('Section Already exists');
                                    } else {
                                        this.toaster.ErrorCustomMessage('There was an unexpected error.');
                                    }
                                }
                            },
                                (error) => {
                                    this.toaster.ErrorCustomMessage('There was an unexpected error.');
                                    this.spinner.hide();
                                }
                            ).add(() => {
                                this.spinner.hide();
                            });
                    }
                });
        }
        catch (err) {
            this.toaster.ErrorCustomMessage('There was an unexpected error.');
            this.spinner.hide();
        }
    }

    refreshLoad(valu: any) {
        try {
            this.router.navigate(['/home'], { queryParams: { 'sectionid': valu.sectionId, 'sectionName': valu.sectionName } }).then(() => {
                //window.location.reload();
                this.utilservice.updatesidebar("reload home");
            });
        } catch (err) { console.log(err); }
    }

    opencatalog() {

        this.router.navigate(['/reload']).then(() => {
            //window.location.reload();
            this.utilservice.updatesidebar("Load catalog");
        });

        // this.router.navigate(['/home/AppCatalog']).then(() => {
        //     //window.location.reload();
        //     this.utilservice.updatesidebar("Load catalog");
        // });


        // this.router.navigateByUrl("/home/AppCatalog").then(() => {
        //     //window.location.reload()
        //     //this.router.onSameUrlNavigation = 'reload';
        //     this.utilservice.updatesidebar("Load catalog");
        // });
    }

    RemoveSelection() {
        try {
            for (var app of this.applnList) {
                app.checked = false;
            }
        } catch (err) { console.log(err); }
    }

    getuserdetails() {
        try {
            var emailid: string = "";
            if ((environment.production != true) && (this.user == null)) {
                emailid = environment.testEmail;
            }
            else {
                this.user = this.userService.getUserInfo();
                if (this.user != null) {
                    emailid = this.user.email;
                }
            }
            return emailid;
        }
        catch (err) { console.log(err); }
    }

    addApplication() {
        try {
            this.spinner.show();
            this.userprofileInfo = this.userService.getUserProfileInfo(this.user.email);
            /*if(this.userprofileInfo!=null)
            {
                this.userprofileInfo=JSON.parse(this.userprofileInfo);
            }*/
            const objtrxndata = {
                "applnname": this.objapplnInfo.applnname,
                "applnurl": this.objapplnInfo.applnurl,
                "applnlogo": this.objapplnInfo.applnlogo,
                "PRNumber": this.userprofileInfo.userPRnumber,
                "appid": 0,
                "email": this.user.email
            }
            this.masterservice.addAppln(objtrxndata)
                .subscribe((result: any) => {
                    const response = result.data;
                    if (response.dictionary.IntResult > 0) {
                        this.toaster.SuccessCustomMessage('Application added successfully.');
                        this.closeBtnApps.nativeElement.click();
                        this.router.navigate(['home']);
                        this.LoadApplication();
                    } else {
                        if (response.dictionary.StringResult.includes('ORA-00001: unique constraint')) {
                            this.toaster.ErrorCustomMessage('Application Already exists');
                        } else {
                            this.toaster.ErrorCustomMessage('There was an unexpected error.');
                        }
                    }
                },
                    (error) => {
                        this.toaster.ErrorCustomMessage('There was an unexpected error.');
                        this.spinner.hide();
                    }
                ).add(() => {
                    this.spinner.hide();
                    //this.closeBtn.nativeElement.click();
                });
        }
        catch (err) {
            this.toaster.ErrorCustomMessage('There was an unexpected error.');
            this.spinner.hide();
        }
    }

    ngOnDestroy() {
        try {
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }
            this.subscription.unsubscribe();
        } catch (err) { console.log(err); }
    }
}